/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypeBanks {
  EghtesadNovin = 1,
  Pasargad = 2,
  Parsian = 3,
  Tat = 4,
  Tejarat = 5,
  Saman = 6,
  Sepah = 7,
  Shahr = 8,
  Saderat = 9,
  Mehr = 10,
  Keshavarzi = 11,
  Gardeshgari = 12,
  Maskan = 13,
  Mellat = 14,
  Melli = 15
}
